import { ThemesPropertyFragment } from '@/generated/contentful'

import { useSlug } from '@/lib/contentful/utils'

import { Link } from '@/components/CustomLink'

type Props = {
	industry?: ThemesPropertyFragment['items'][0]
	sideBar?: boolean
}

export const ThemesIndustryLink = ({ industry, sideBar = false }: Props) => {
	const slug = useSlug()
	const count = industry?.linkedFrom?.marketplaceThemeCollection?.total

	if (count === 0) {
		return null
	}

	return (
		<Link
			href={
				industry?.slug === 'theme-store' ? `/${industry.slug}` : `/theme-store/${industry?.slug}`
			}
			className={
				sideBar
					? `text-gray-500 my-2 cursor-pointer ${
							slug === industry?.slug || (!slug && industry?.slug === 'theme-store')
								? 'underline underline-offset-8 decoration-bc-blue'
								: ''
					  }`
					: `text-bc-blue font-medium`
			}
		>
			{industry?.slug === 'theme-store' ? (
				industry.name
			) : (
				<>
					{industry?.name}
					<span className="text-gray-500"> ({count})</span>
				</>
			)}
		</Link>
	)
}
